import { __assign, __rest } from "tslib";
import React from 'react';
import { cnHeader, cnHeaderImage } from '../Header.const';
import { Link } from '../../Link/Link';
import { getLogoaasUrl } from './Logoaas.utils';
import './Logoaas.css';
/**
 * Компонент для отрисовки логотипа на основе logoaas
 *
 * @default "Яндекс"
 * @see https://github.yandex-team.ru/soft/logoaas
 * @param {LogoaasProps} props
 */
export var Logoaas = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 32 : _b, _c = _a.color, color = _c === void 0 ? '000' : _c, _d = _a.first, first = _d === void 0 ? 'f00' : _d, _e = _a.tld, tld = _e === void 0 ? 'ru' : _e, _f = _a.circle, circle = _f === void 0 ? false : _f, href = _a.href, _g = _a.name, name = _g === void 0 ? 'Яндекс' : _g, className = _a.className, single = _a.single, rebranding = _a.rebranding, rest = __rest(_a, ["size", "color", "first", "tld", "circle", "href", "name", "className", "single", "rebranding"]);
    var baseUrl = href ? href : "//yandex." + tld;
    var baseLogo = getLogoaasUrl({ name: name, size: size, color: color, first: first, circle: circle, single: single, rebranding: rebranding });
    return (React.createElement(Link, __assign({}, rest, { className: cnHeader('Logoaas', { rebranding: rebranding }, [className]), href: baseUrl, tabIndex: -1 }),
        React.createElement("img", { className: cnHeaderImage, src: baseLogo })));
};
